// Commission rule DAO — CRUD + list for commission_rules.

import { BaseDao, type SupabaseClient, type MutationOptions } from '../base.ts';
import type { CommissionRule } from '@shared/types/commission.ts';

const RULE_SELECT =
  '*, commission_payees(id, name), companies(id, short_name), products(id, name)';

export class CommissionRuleDao extends BaseDao<CommissionRule> {
  protected readonly dependentResources = ['commission_rules'];
  protected readonly defaultSelect = RULE_SELECT;

  constructor(sb: SupabaseClient) {
    super(sb, 'commission_rules');
  }

  async list(opts?: { includeDeleted?: boolean }): Promise<CommissionRule[]> {
    let q = this.sb
      .from('commission_rules')
      .select(RULE_SELECT)
      .order('priority', { ascending: false });
    if (!opts?.includeDeleted) q = q.eq('is_deleted', false);
    const { data, error } = await q;
    if (error) throw error;
    return (data ?? []) as CommissionRule[];
  }

  async softDelete(id: number, opts?: MutationOptions): Promise<void> {
    await this.update(id, { is_deleted: true } as Partial<CommissionRule>, opts);
  }
}
